import { Link } from 'react-router-dom';
import { AppFooter } from '../branding/AppFooter';
import { AppHeader } from '../branding/AppHeader';
import { BRAND_NAME, BRAND_TAGLINE } from '../branding/branding';
import './marketing.css';

/** Static About page. Linked from the AppFooter on every page. */
export function AboutPage(): JSX.Element {
  return (
    <div className="bl-page">
      <AppHeader subBrand="About" privacy="on-device" />
      <main className="bl-marketing">
        <header className="bl-marketing__hero">
          <p className="bl-marketing__eyebrow">About</p>
          <h1>{BRAND_TAGLINE}</h1>
          <p className="bl-marketing__lead">
            {BRAND_NAME} is a machine-learning studio for kids 8–14 and the grown-ups around them.
            Train a model from your webcam or microphone, give it behavior with blocks, then ship it
            to a phone, a website, or a tiny chip.
          </p>
        </header>

        <section className="bl-marketing__section">
          <h2>What we believe</h2>
          <ul className="bl-marketing__bullets">
            <li>
              <strong>Training stays on-device by default.</strong> Your webcam frames never touch a
              server unless you choose to publish a project.
            </li>
            <li>
              <strong>Latency is a feature.</strong> A 10-year-old won&rsquo;t wait 30 seconds for a
              model to train, so we don&rsquo;t make them.
            </li>
            <li>
              <strong>Mistakes are reversible.</strong> Undo, reset, start over — first-class.
            </li>
            <li>
              <strong>Honesty about uncertainty.</strong> Confidence scores reflect real
              generalization, not training-set memorization.
            </li>
            <li>
              <strong>Patronizing aesthetics are worse than serious ones.</strong> We treat the kid
              as a maker.
            </li>
          </ul>
        </section>

        <section className="bl-marketing__section">
          <h2>For grown-ups</h2>
          <p>
            Photos and audio stay in the browser while a kid trains. Server upload only happens when
            a kid explicitly publishes a project to the public gallery — and that takes parental
            approval if the kid is under 13.
          </p>
          <p>
            Read the full <Link to="/privacy">privacy policy</Link>, or{' '}
            <Link to="/contact">get in touch</Link> with a question or a feature idea.
          </p>
        </section>

        <section className="bl-marketing__section">
          <h2>How to start</h2>
          <p>
            Click <Link to="/studio">Open the studio</Link>, or browse{' '}
            <Link to="/gallery">the gallery</Link> to see what other kids have made.
          </p>
        </section>
      </main>
      <AppFooter />
    </div>
  );
}
